// @ts-nocheck

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';

const StyledButton = styled.button`
  && {
    color: #fff;
    border-radius: 1.5em;
    border: solid 1px
      ${({ $withRedBorder, theme }) => ($withRedBorder ? theme.grids.colors.redlight : theme.grids.colors.middlegrey3)};
    min-width: 6em;
    padding: 0.4em 1em;
    background-color: transparent;
    font-family: BettingPoliticaExtraBold, sans-serif;
    font-weight: 800;
    cursor: pointer;
    transition:
      border-color 300ms ease-out,
      background-color 300ms ease-out,
      color 300ms ease-out;

    ${({ $withRedBorder, theme }) =>
      Target.__MOBILE__
        ? css`
            &:active {
              background-color: ${$withRedBorder ? theme.grids.colors.redlight : '#fff'};
              border-color: ${$withRedBorder ? theme.grids.colors.redlight : '#fff'};
              color: ${$withRedBorder ? '#fff' : theme.grids.colors.black};
            }
          `
        : css`
            &:hover {
              background-color: ${$withRedBorder ? theme.grids.colors.redlight : '#fff'};
              border-color: ${$withRedBorder ? theme.grids.colors.redlight : '#fff'};
              color: ${$withRedBorder ? '#fff' : theme.grids.colors.black};
            }
          `}
  }
`;

type Props = {
  className?: string;
  children: Node;
  onClick?: () => void;
  withRedBorder?: boolean;
};

const Secondary = ({ className, children, onClick, withRedBorder = false }: Props) => {
  return (
    <StyledButton className={className} $withRedBorder={withRedBorder} onClick={onClick}>
      {children}
    </StyledButton>
  );
};

export default Secondary;
